import * as React from 'react';

import { Shimmer } from '../../../../../../../../common/Shimmer';

import * as styles from './BetPositionTooltip.css';

interface IProps {
  children: React.ReactNode;
}

export const BetPositionTooltip = ({ children }: IProps) => (
  <div className={styles['tooltip']}>
    <Shimmer theme="black" running={false}>
      <div className={styles['content']}>{children}</div>
    </Shimmer>
  </div>
);
